// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-31b7f54a]{text-align:right}@media screen and (max-width:767px){.main-menu[data-v-31b7f54a]{padding-top:40px}.main-menu li[data-v-31b7f54a]{margin-bottom:10px}}", ""]);
// Exports
module.exports = exports;
